// extracted by mini-css-extract-plugin
export default {"Conteudo":"estilo_Conteudo__GGRtT","Mensagem":"estilo_Mensagem__yqD4C"};